import { useContext, useEffect } from "react";
import { MapContext } from "../../MapContext";
import { registerOlInteraction } from "../helpers";

import { PinchZoom } from "ol/interaction";

export default function PinchZoomInteraction(props) {
  const context = useContext(MapContext);

  const options = {
    duration: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, PinchZoom, props, options, events),
    []
  );

  return null;
}
